import React, { useEffect } from 'lib/react';
import {
  EVButton, EVGrid, makeStyles, EVPrintOutlinedIcon,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import history from 'store/CreateHistory';
import { ORDER_ROUTE } from 'constants/RouteConstants';
import { useSelector, useDispatch } from 'lib/redux';
import { openCancelOrderDialog, fetchOrderClosureReasons } from 'features/cancel-order-dialog/CancelOrder.actions';

const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '24px',
    justifyContent: 'space-between',
    '&>button': {
      width: '100%',
      textTransform: 'none',
    },
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      columnGap: '16px',
      '&>button': {
        width: 'unset',
        '&>span': { columnGap: '8px' },
      },
    },
  },
}));

function Buttons() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { reportDetails } = useSelector(({ orderSubmitted }) => orderSubmitted);
  const dispatch = useDispatch();
  useEffect(() => dispatch(fetchOrderClosureReasons()), []);

  const handleCancelOrder = () => {
    dispatch(openCancelOrderDialog(
      reportDetails.map((report) => report.reportId),
      reportDetails[0]?.address,
    ));
  };

  return (
    <EVGrid className={classes.buttons}>
      <EVButton id="printPageBtn" variant="outlined" color="primary" onClick={window.print}>
        <EVPrintOutlinedIcon />
        {t('order_submitted__print_page')}
      </EVButton>
      <EVGrid className={classes.buttons}>
        <EVButton id="cancelOrderBtn" variant="outlined" color="primary" onClick={handleCancelOrder}>
          {t('order_submitted__cancel_order')}
        </EVButton>
        <EVButton id="placeOrderBtn" variant="contained" color="primary" onClick={() => history.push(ORDER_ROUTE)}>
          {t('order_submitted__place_another_order')}
        </EVButton>
      </EVGrid>
    </EVGrid>
  );
}

export default Buttons;
